import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { AddOn } from '../schemas/add-on';

/**
 * Remove a single product license from a specific User
 * @param productId ID of the product to remove
 * @param externalId External ID of the User
 */
export function deleteLicenseProductId(
  this: unknown,
  productId: number,
  externalId: string,
  addons?: AddOn[]
) {
  let url = `${
    accountsEnvironment.resolve(this).licenseUrl
  }/${encodeURIComponent(productId)}`;
  if (addons && addons.length >= 1) {
    url += `?${addons.map((addon) => `addons=${addon}`).join('&')}`;
  }
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(url, {
        method: 'DELETE',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
        body: JSON.stringify({ externalId }),
      })
    )
  ).pipe(ignoreData());
}
